(() => {

  function initQuantityShortcuts() {

    const quantityInputs = document.querySelectorAll(
      '.product__info-container quantity-input, [id^="MainProduct-"] quantity-input'
    );

    quantityInputs.forEach((quantityComponent) => {

      if (quantityComponent.dataset.egQuickQtyReady === 'true') {
        return;
      }

      const input = quantityComponent.querySelector(
        'input[type="number"], .quantity__input'
      );

      if (!input) return;

      quantityComponent.dataset.egQuickQtyReady = 'true';


      const wrapper = document.createElement('div');

      wrapper.className = 'eg-quick-qty';

      wrapper.innerHTML = `
        <div class="eg-quick-qty__label">
          まとめて選ぶ
        </div>

        <div class="eg-quick-qty__buttons">

          <button type="button" data-eg-qty="1">
            1個
          </button>

          <button type="button" data-eg-qty="5">
            5個
          </button>

          <button type="button" data-eg-qty="10">
            10個
          </button>

          <button type="button" data-eg-qty="20">
            20個
          </button>

        </div>
      `;


      quantityComponent.insertAdjacentElement(
        'afterend',
        wrapper
      );


      const buttons = wrapper.querySelectorAll(
        '[data-eg-qty]'
      );


      function getMin() {

        const min = parseInt(
          input.getAttribute('min'),
          10
        );

        return Number.isNaN(min) ? 1 : min;

      }


      function getMax() {

        const max = parseInt(
          input.getAttribute('max'),
          10
        );

        return Number.isNaN(max) ? null : max;

      }


      function updateSelectedButton() {

        const current =
          parseInt(input.value, 10) || 1;

        buttons.forEach((button) => {

          const quantity =
            parseInt(
              button.dataset.egQty,
              10
            );

          button.classList.toggle(
            'is-selected',
            quantity === current
          );

        });

      }


      function setQuantity(quantity) {

        const min = getMin();

        const max = getMax();


        if (quantity < min) {

          quantity = min;

        }


        if (
          max !== null &&
          quantity > max
        ) {

          quantity = max;

        }


        input.value = quantity;


        input.dispatchEvent(
          new Event(
            'input',
            {
              bubbles: true
            }
          )
        );


        input.dispatchEvent(
          new Event(
            'change',
            {
              bubbles: true
            }
          )
        );


        updateSelectedButton();

      }


      buttons.forEach((button) => {

        button.addEventListener(
          'click',
          () => {

            setQuantity(
              parseInt(
                button.dataset.egQty,
                10
              )
            );

          }
        );

      });


      input.addEventListener(
        'input',
        updateSelectedButton
      );


      input.addEventListener(
        'change',
        updateSelectedButton
      );


      updateSelectedButton();

    });

  }


  document.addEventListener(
    'DOMContentLoaded',
    initQuantityShortcuts
  );


  document.addEventListener(
    'shopify:section:load',
    initQuantityShortcuts
  );


  const observer =
    new MutationObserver(
      initQuantityShortcuts
    );


  observer.observe(
    document.documentElement,
    {
      childList: true,
      subtree: true
    }
  );

})();